import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { Button, FlexColumn, GridRow, IconButton, OverflowText } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import { white } from "designSystem/styles/color";
import { ComponentItem } from "designSystem/types/component-item-types";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { CompositionMaterial, createCompositionTypeKey, useCompositionStore } from "./CompositionStore";
import { TypeVariantSection } from "./TypeVariantSection";

interface CompositionSingleItemProps {
	item: CompositionMaterial;
}

const CompositionSingleItem: FunctionComponent<CompositionSingleItemProps> = observer(function CompositionSingleItem(props) {
	const {
		item,
	} = props;
	const {
		buttonDisabled,
		compositionKey,
		compositionNode,
		compositionTypes,
		removeCompositionType,
		setItemsForDropdown,
	} = item;

	const { removeComposition, addCompositionTypeVariant } = useCompositionStore();
	const loc = useLocale();
	const name = loc.getNodeName(compositionNode);

	return (
		<FlexColumn
			bgcolor={white[50]}
			borderRadius="3px"
			flexGrow={1}
			gap={3}
			marginBottom={3}
			padding={2}
		>
			<GridRow
				alignItems="center"
				flexWrap="nowrap"
				growChild={0}
			>
				<OverflowText bold text={name} />
				<IconButton onClick={() => removeComposition(compositionKey)} size="small">
					<CloseIcon />
				</IconButton>
			</GridRow>
			{compositionTypes
				?.map((type, index) => {
					const { url }  = type;
					const key = createCompositionTypeKey(
						index,
						url,
					);
					const items: ComponentItem[] = setItemsForDropdown(url);
					return (
						<TypeVariantSection 
							index={index}
							isSingleComposition={compositionTypes.length === 1}
							item={type}
							items={items}
							key={key}
							removeTypeVariant={removeCompositionType}
						/>
					);
				})}
			<GridRow justifyContent="flex-start">
				<Button
					design="link"
					disabled={buttonDisabled}
					onClick={() => addCompositionTypeVariant(compositionKey)}
					res="CompositionNewType"
					startIcon={<AddIcon />}
					sx={{ padding: 0 }} 
				/>
			</GridRow>
		</FlexColumn>
	);
});

export default CompositionSingleItem;